import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectDealerProfile } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertsComponent implements OnInit{


  myProfile$: Observable<Dealer>;

  constructor(
    private store: Store, 

    private route: ActivatedRoute) {
      this.myProfile$ = this.store.select(selectDealerProfile);
    }
  
  ngOnInit(): void {

    this.myProfile$.subscribe( (dealer: Dealer) => {
      //this.dealerData = dealer;
    }

    );
  } 
}
